import Vue from 'vue'
import VoerroTagsInput from '@voerro/vue-tagsinput';
Vue.component('vue-tagsinput', VoerroTagsInput);
import '@voerro/vue-tagsinput/dist/style.css';